<template>
  <div>
    <inputField
      id="name"
      label="申請人姓名"
      placeholder="請輸入"
      inputType="name"
      maxLength="50"
      class="record-name"
      @onInput="onInput($event)"
      :errorText="errorText.name"
    />
    <inputField
      id="phone"
      label="手機號碼/聯絡電話"
      placeholder="請輸入"
      inputType="phone"
      maxLength="11"
      class="record-phone"
      @onInput="onInput($event)"
      :errorText="errorText.phone"
    />
    <div class="clear" />
    <div class="record-footer-query">
      <div
        class="temple-button-text record-footer-query-button"
        @click="queryClick"
      >
        查詢
      </div>
    </div>
  </div>
</template>

<script>
import inputField from 'Components/inputField/inputField.vue';
import validation from 'Core/validation.js';
import scrollToElement from 'scroll-to-element';

export default {
  name: 'ServiceRecordStep1',
  components: {
    inputField,
  },
  data() {
    return {
      info: {
        name: '',
        phone: '',
      },
      errorText: {
        name: '',
        phone: '',
      },
    };
  },
  mounted() {
    window.scrollTo({ behavior: 'auto', top: 0 });
  },
  methods: {
    queryClick() {
      this.validateFormat() && this.goQueryRecord();
    },
    goQueryRecord() {
      this.$emit('queryRecord', this.info);
    },
    onInput(inputValue) {
      Object.assign(this.info, inputValue);
    },
    // 參數格式是否正確
    validateFormat() {
      Object.keys(this.info).forEach((element) => {
        if (this.info[element] === '') {
          this.errorText[element] = '必填';
        } else if (!validation[element].regex.test(this.info[element])) {
          this.errorText[element] = validation[element].msg;
        } else {
          this.errorText[element] = '';
        }
      });

      return this.checkError();
    },
    // 確認有無error
    checkError() {
      let validateResult = true;
      let scrollFirstElement = true;
      Object.keys(this.errorText).forEach((element) => {
        if (this.errorText[element] !== '') {
          if (scrollFirstElement) {
            scrollToElement(`#${element}`, {
              offset: window.innerWidth < 768 ? -100 : -190,
              ease: 'out-circ',
              duration: 500,
            });
            scrollFirstElement = false;
          }
          validateResult = false;
        }
      });
      return validateResult;
    },
  },
};
</script>

<style scoped>
.record-name {
  margin-top: 30px;
}

.record-phone {
  margin-top: 10px;
}

.record-footer-query {
  margin-top: 50px;
  align-items: center;
  display: flex;
  justify-content: center;
}

@media (min-width: 768px) {
  .clear {
    box-sizing: border-box;
    height: 100px;
  }

  .record-name,
  .record-phone {
    width: calc(50% - 20px);
  }

  .record-name {
    float: left;
  }

  .record-phone {
    float: right;
  }

  .record-phone {
    margin-top: 30px;
  }

  .record-footer-query {
    margin-top: 150px;
  }
}
</style>
